import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsWidgetRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels-widget',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
	exact: true,
};
